/* eslint-disable sonarjs/no-duplicate-string */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Badge, Box, HStack, List, ListIcon, ListItem, mode, Text, Tooltip, useColorMode, VStack } from '@abb/uikit';
import { ChevronDown } from '@abb/uikit/icons/outline/arrow';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
const NavigationLink = (param)=>{
    let { href, menuItem, onSidebarOpen, children, onClick } = param;
    return /*#__PURE__*/ _jsx(Link, {
        to: href,
        onClick: (e)=>{
            var _menuItem_onClick;
            onSidebarOpen === null || onSidebarOpen === void 0 ? void 0 : onSidebarOpen();
            (_menuItem_onClick = menuItem.onClick) === null || _menuItem_onClick === void 0 ? void 0 : _menuItem_onClick.call(menuItem);
            onClick === null || onClick === void 0 ? void 0 : onClick(e);
        },
        style: {
            width: '100%'
        },
        children: children
    });
};
const NavigationLinkDisabled = (param)=>{
    let { text, children } = param;
    return /*#__PURE__*/ _jsx(Tooltip, {
        label: text,
        placement: "right",
        children: /*#__PURE__*/ _jsx(Box, {
            style: {
                opacity: 0.6,
                width: '100%',
                cursor: 'not-allowed'
            },
            children: children
        })
    });
};
export const Navigation = (param)=>{
    let { links, onSidebarOpen } = param;
    const location = useLocation();
    const { colorMode } = useColorMode();
    const [openedMenu, setOpenedMenu] = useState(null);
    const { t } = useTranslation('common');
    const toggleMenu = (item)=>{
        if (item.id === openedMenu) setOpenedMenu(null);
        else setOpenedMenu(item.id);
    };
    useEffect(()=>{
        links.some((item)=>{
            var _item_submenu;
            const hasActiveSub = (_item_submenu = item.submenu) === null || _item_submenu === void 0 ? void 0 : _item_submenu.some((submenuItem)=>{
                var _submenuItem_href, _location_pathname;
                return ((_submenuItem_href = submenuItem.href) === null || _submenuItem_href === void 0 ? void 0 : _submenuItem_href.split('?')[0].split('/').slice(1, 3).join('/')) === ((_location_pathname = location.pathname) === null || _location_pathname === void 0 ? void 0 : _location_pathname.split('/').slice(1, 3).join('/'));
            });
            if (hasActiveSub) {
                setOpenedMenu(item.id);
                return true;
            } else {
                setOpenedMenu(null);
            }
        });
    }, [
        location.pathname
    ]);
    /* eslint-disable sonarjs/cognitive-complexity */ return /*#__PURE__*/ _jsx(Box, {
        children: /*#__PURE__*/ _jsx(List, {
            w: "100%",
            children: links === null || links === void 0 ? void 0 : links.map((item, index)=>{
                var _item_submenu, _item_submenu1;
                const isActive = location.pathname === item.href;
                const hasActiveSub = item.submenu.some((submenuItem)=>location.pathname === submenuItem.href.split('?')[0]);
                return !item.isHidden && /*#__PURE__*/ _jsxs(ListItem, {
                    id: item.id,
                    children: [
                        ((_item_submenu = item.submenu) === null || _item_submenu === void 0 ? void 0 : _item_submenu.length) > 0 ? /*#__PURE__*/ _jsxs(HStack, {
                            className: "outer-stack",
                            alignItems: "center",
                            justifyContent: "start",
                            borderRadius: "12px",
                            cursor: "pointer",
                            gap: {
                                base: 4,
                                md: 2
                            },
                            onClick: ()=>toggleMenu(item),
                            _hover: {
                                backgroundColor: mode('rgba(27, 99, 237, 0.12)', 'whiteAlpha.100')({
                                    colorMode
                                })
                            },
                            backgroundColor: isActive || hasActiveSub ? mode('rgba(27, 99, 237, 0.12)', 'whiteAlpha.100')({
                                colorMode
                            }) : 'transparent',
                            p: 3,
                            children: [
                                /*#__PURE__*/ _jsx(ListIcon, {
                                    as: item.icon,
                                    color: isActive || hasActiveSub ? '#1B63ED' : mode('rgba(72, 74, 79, 1)', 'rgba(196, 199, 204, 1)')({
                                        colorMode
                                    }),
                                    width: {
                                        base: 6,
                                        md: 5
                                    },
                                    height: {
                                        base: 6,
                                        md: 5
                                    }
                                }),
                                /*#__PURE__*/ _jsx(Tooltip, {
                                    display: item.title.length > 25 ? 'block' : item.isNew && item.title.length > 20 ? 'block' : 'none',
                                    label: item.title,
                                    children: /*#__PURE__*/ _jsx(Text, {
                                        color: isActive || hasActiveSub ? '#1B63ED' : mode('rgba(72, 74, 79, 1)', 'rgba(196, 199, 204, 1)')({
                                            colorMode
                                        }),
                                        fontWeight: 500,
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        fontSize: {
                                            base: '14px',
                                            md: 'sm'
                                        },
                                        whiteSpace: "nowrap",
                                        children: item.title
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Box, {
                                    transform: `rotate(${item.id === openedMenu ? '180deg' : '0deg'})`,
                                    ml: "auto!important",
                                    children: /*#__PURE__*/ _jsx(ChevronDown, {
                                        stroke: isActive || hasActiveSub ? '#1B63ED' : mode('rgba(72, 74, 79, 1)', 'rgba(196, 199, 204, 1)')({
                                            colorMode
                                        })
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ _jsx(Link, {
                            to: item.href,
                            onClick: ()=>{
                                var _item_onClick;
                                onSidebarOpen === null || onSidebarOpen === void 0 ? void 0 : onSidebarOpen();
                                (_item_onClick = item.onClick) === null || _item_onClick === void 0 ? void 0 : _item_onClick.call(item);
                            },
                            children: /*#__PURE__*/ _jsxs(HStack, {
                                className: "outer-stack",
                                position: "relative",
                                alignItems: "center",
                                justifyContent: "space-between",
                                borderRadius: "12px",
                                cursor: "pointer",
                                gap: {
                                    base: 4,
                                    md: 2
                                },
                                _hover: {
                                    backgroundColor: mode('rgba(27, 99, 237, 0.12)', 'whiteAlpha.100')({
                                        colorMode
                                    })
                                },
                                backgroundColor: isActive ? mode('rgba(27, 99, 237, 0.12)', 'whiteAlpha.100')({
                                    colorMode
                                }) : 'transparent',
                                p: 3,
                                children: [
                                    /*#__PURE__*/ _jsxs(HStack, {
                                        gap: {
                                            base: 4,
                                            md: 2
                                        },
                                        children: [
                                            /*#__PURE__*/ _jsx(ListIcon, {
                                                as: item.icon,
                                                color: isActive ? '#1B63ED' : mode('rgba(72, 74, 79, 1)', 'rgba(196, 199, 204, 1)')({
                                                    colorMode
                                                }),
                                                width: {
                                                    base: 6,
                                                    md: 5
                                                },
                                                height: {
                                                    base: 6,
                                                    md: 5
                                                }
                                            }),
                                            /*#__PURE__*/ _jsx(Text, {
                                                color: isActive || hasActiveSub ? '#1B63ED' : mode('rgba(72, 74, 79, 1)', 'rgba(196, 199, 204, 1)')({
                                                    colorMode
                                                }),
                                                overflow: "hidden",
                                                fontWeight: 500,
                                                fontSize: {
                                                    base: '14px',
                                                    md: 'sm'
                                                },
                                                whiteSpace: "nowrap",
                                                marginInlineStart: 0,
                                                children: item.title
                                            })
                                        ]
                                    }),
                                    item.isNew && /*#__PURE__*/ _jsx(Badge, {
                                        m: "0 !important",
                                        p: "2px 6px",
                                        fontWeight: "600",
                                        lineHeight: "16px",
                                        fontSize: "11px",
                                        color: "white",
                                        backgroundColor: "red",
                                        borderRadius: "12px",
                                        children: item.badgeText || t('menu.featureBadge')
                                    })
                                ]
                            })
                        }),
                        item.submenu && /*#__PURE__*/ _jsx(VStack, {
                            display: item.id === openedMenu ? 'flex' : 'none',
                            align: "start",
                            my: 1,
                            gap: 0,
                            inset: {
                                base: 0,
                                md: 'unset'
                            },
                            background: {
                                base: mode('#F0F0F0', '#0A0B0D')({
                                    colorMode
                                }),
                                md: 'unset'
                            },
                            children: (_item_submenu1 = item.submenu) === null || _item_submenu1 === void 0 ? void 0 : _item_submenu1.map((submenuItem, index)=>{
                                var _submenuItem_href, _location_pathname;
                                const isActive = ((_submenuItem_href = submenuItem.href) === null || _submenuItem_href === void 0 ? void 0 : _submenuItem_href.split('?')[0].split('/').slice(1, 3).join('/')) === ((_location_pathname = location.pathname) === null || _location_pathname === void 0 ? void 0 : _location_pathname.split('/').slice(1, 3).join('/'));
                                const SubmenuLink = !submenuItem.isDisabled ? NavigationLink : NavigationLinkDisabled;
                                return /*#__PURE__*/ _jsx(Box, {
                                    position: "relative",
                                    w: "calc(100% - 12px)",
                                    borderLeft: "2px",
                                    ml: "12px",
                                    borderColor: mode('#0A0B0D1F', '#FFFFFF14')({
                                        colorMode
                                    }),
                                    children: !(submenuItem === null || submenuItem === void 0 ? void 0 : submenuItem.isHidden) && /*#__PURE__*/ _jsx(SubmenuLink, {
                                        href: submenuItem.href,
                                        onSidebarOpen: onSidebarOpen,
                                        menuItem: item,
                                        text: submenuItem.disabledText,
                                        onClick: submenuItem.onClick,
                                        children: /*#__PURE__*/ _jsxs(HStack, {
                                            "data-test-id": submenuItem.id,
                                            alignItems: "center",
                                            position: "relative",
                                            left: "-2px",
                                            justifyContent: "space-between",
                                            cursor: "pointer",
                                            gap: 2,
                                            px: 3,
                                            my: 3,
                                            borderLeft: "2px",
                                            borderColor: isActive ? '#1B63ED' : 'transparent',
                                            w: "100%",
                                            _hover: {
                                                backgroundColor: 'whiteAlpha.200'
                                            },
                                            ...submenuItem.isDisabled ? {
                                                cursor: 'not-allowed'
                                            } : {},
                                            children: [
                                                /*#__PURE__*/ _jsx(Tooltip, {
                                                    display: submenuItem.title.length > 25 ? 'block' : submenuItem.isNew && submenuItem.title.length > 20 ? 'block' : 'none',
                                                    label: submenuItem.title,
                                                    children: /*#__PURE__*/ _jsx(Text, {
                                                        fontWeight: 500,
                                                        fontSize: {
                                                            base: '14px',
                                                            md: 'sm'
                                                        },
                                                        ml: {
                                                            base: '28px',
                                                            md: '18px'
                                                        },
                                                        whiteSpace: "nowrap",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                        color: isActive ? mode('#0A0B0D', '#FFFFFF')({
                                                            colorMode
                                                        }) : '#7A7D82',
                                                        children: submenuItem.title
                                                    })
                                                }),
                                                submenuItem.isNew && /*#__PURE__*/ _jsx(Badge, {
                                                    p: "2px 6px",
                                                    fontWeight: "600",
                                                    lineHeight: "16px",
                                                    fontSize: "10px",
                                                    color: "white",
                                                    backgroundColor: "red",
                                                    borderRadius: "6px",
                                                    children: t('menu.featureBadge')
                                                })
                                            ]
                                        })
                                    })
                                }, index);
                            })
                        })
                    ]
                }, index);
            })
        })
    });
};
